// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

// Lib
import router from '@/lib/router'
// import head from '@/lib/head'
import store from '@/lib/store'
import meta from '@/lib/meta'

// Plugins
import dialog from './lib/dialog'
Vue.use(dialog)
import snackbar from './lib/snackbar'
Vue.use(snackbar)
import bus from './lib/bus'
Vue.use(bus)
import filters from './lib/filters'
Vue.use(filters)

// Config
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	render: h => h(App),
	router,
	store,
	// head: head,
})



// WEBPACK FOOTER //
// ./src/main.js